import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environment';

export const SERVER_API_URL = environment.serverUrl;
const routes = {
  signIn: {
    vendor_login: () => `${SERVER_API_URL}/api/v1/VendorLogin`,
    vendorchangepassword: (vendorId: number) => `${SERVER_API_URL}/api/v1/changeVendorPassword/${vendorId}`,
    vendorforgotpassword: () => `${SERVER_API_URL}/api/v1/VendorPasswordReset`,
    vendorotpverification: () => `${SERVER_API_URL}/api/v1/verifyVendorOtp`,
    vendorresetpassoword: () => `${SERVER_API_URL}/api/v1/updateVendorPassword`,
    vendorbyid: (vendor_id: number) => `${SERVER_API_URL}/api/v1/getVendorByIId/${vendor_id}`,
    invoicecount: () => `${SERVER_API_URL}/api/v1/getPaymentStatusCount`,
  },

};
@Injectable({ providedIn: 'root', })
export class VendorLoginService {

  constructor(private http: HttpClient) { }

  userLogin(data: any): Observable<any> {
    return this.http.post<any>(routes.signIn.vendor_login(), data, { observe: 'response' });
  }

  vendorchangepassword(vendorId: number, data: any): Observable<any> {
    return this.http.put<any>(routes.signIn.vendorchangepassword(vendorId), data, { observe: 'response' });
  }

  vendorforgotpassword(payload: { mailId: string }): Observable<any> {
    return this.http.post<any>(routes.signIn.vendorforgotpassword(), payload, { observe: 'response' });
  }

  vendorotpverification(payload: { mailId: string; otp: string }): Observable<any> {
    return this.http.post<any>(routes.signIn.vendorotpverification(), payload, { observe: 'response' });
  }

  vendorresetpassoword(data: any): Observable<any> {
    return this.http.put<any>(routes.signIn.vendorresetpassoword(), data, { observe: 'response' });
  }

  vendorById(vendor_id: number): Observable<any> {
    return this.http.get<any>(routes.signIn.vendorbyid(vendor_id), { observe: 'response' });
  }

  invoicelistdashboardcount(): Observable<any> {
    return this.http.get<any>(routes.signIn.invoicecount(), { observe: 'response' });
  }

}